import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { catchError, defer, finalize, map, of } from 'rxjs';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { FullPageMaskService, SpinnerModule } from 'common';
import { CommonModule } from '@angular/common';
import { Status } from '../../../interfaces/status.interface';
import { StatusDesc } from '../../../interfaces/status-desc.interface';
import { toRepresentativeName } from '../../../utilities/objects/to-representative-name.utilities';
import { StatusDirective } from '../../../directives/status-color.directive';
import { SenderIdService } from '../../../services/sender-id-api.service';
import { SenderIdSameAccountListItem } from '../../../interfaces/sender-id-same-account-list-item.interface';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';

export interface OrganisationSidoDialogData {
  senderId: number;
  organisation: string;
}

@Component({
  selector: 'si-organisation-sido-dialog',
  standalone: true,
  imports: [MatDialogModule, MatButtonModule, MatTableModule, CommonModule, StatusDirective, SpinnerModule, MatIconModule, RouterLink],
  templateUrl: './organisation-sido-dialog.component.html',
  styleUrls: ['./organisation-sido-dialog.component.scss'],
})
export class OrganisationSidoDialogComponent {
  public readonly columns = ['senderIDtext', 'status'];
  public readonly statuses = toRepresentativeName(Status, StatusDesc);

  private readonly maskService = inject(FullPageMaskService);
  private readonly dialogRef = inject(MatDialogRef<OrganisationSidoDialogComponent>);
  private readonly senderIdService = inject(SenderIdService);
  public data = inject<OrganisationSidoDialogData>(MAT_DIALOG_DATA);
  public isFetching = true;

  public dataSource$ = defer(() => {
    this.maskService.showLoading();
    return this.senderIdService.getSenderIdSameAccountList$(this.data.senderId);
  }).pipe(
    map((data) => new MatTableDataSource<SenderIdSameAccountListItem>(data)),
    finalize(() => {
      this.maskService.hideLoading();
      this.isFetching = false;
    }),
    catchError(() => {
      return of(new MatTableDataSource<SenderIdSameAccountListItem>([]));
    })
  );

  handleClose() {
    this.dialogRef.close();
  }
}
